import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  maxWidth: (p) => p.spacing(150),
  mx: 'auto',
};
